<template>
  <div class="tradeModel stoplossrecordModel">
    <div class="layout">
      <!-- <div class="money">
                <ul>
                    <li><p>交易總手數</p><span>0.8手</span></li>
                </ul>
            </div> -->
      <div class="reportTit">
        <p>共计{{ stop.totalSize }}条记录</p>
        <div class="search-box">
          <form @submit.prevent>
            <input v-model="positionId" placeholder="请输入持仓号">
            <button type="submit" @click="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>

    <div>
      <div v-if="stop.recordList" class="reportList">
        <ul v-if="stop.recordList.length>0">
          <li v-for="item in stop.recordList" :key="item.id" @click="selectStopPro(item.positionId)">
            <div class="item marginBottom item2">
              <div class="itemCol itemCol1">
                <div class="tStart"><span class="cb pd-name">{{ item.displayName }}</span>#{{ item.positionId }}</div>
                <div class="tEnd">{{ item.exectime }}</div>
              </div>
              <div class="itemCol itemCol2">
                <div class="tCol">
                  <div><div>止损</div></div>
                  <div><div>{{ item.stoploss==''?'--':item.stoploss }}</div></div>
                  <div><div>止盈</div></div>
                  <div><div>{{ item.takeprofit==''?'--':item.takeprofit }}</div></div>
                </div>
                <div class="tCol">
                  <div><div>持仓手数</div></div>
                  <div><div>{{ item.execvolume }}手</div></div>
                  <div><div>{{ item.reportType }}价</div></div>
                  <div><div>{{ item.tradePriceStr }}</div></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <noData v-else />
      </div>
    </div>

    <!--额度详情-->
    <div v-if="isShowStop" class="popFixed">
      <div class="masking" @click="closeStopPop" />
      <div class="tcCon">
        <div class="holdBank between">
          <div class="item">
            <span>实时动态</span>
            <div><img class="realtime_ico" src="@/assets/images/report/realtime_ico.png"></div>
            <div v-if="stopRecordList.recordList !== undefined && stopRecordList.recordList.length>0" class="rList">
              <div v-for="item in stopRecordList.recordList" :key="item.id">
                <div><div>时间</div><div>{{ item.uutime }}</div></div>
                <div>
                  <div>{{ item.takeProfitFrom&&parseFloat(item.takeProfitTo).toFixed(0)==0 || item.stopLossFrom&&parseFloat(item.stopLossTo).toFixed(0)==0 ? "取消" : "设置止盈止损" }}</div>
                  <div>
                    <div v-if="item.takeProfitFrom&&parseFloat(item.takeProfitTo).toFixed(0)==0 || item.stopLossFrom&&parseFloat(item.stopLossTo).toFixed(0)==0">
                      {{ item.modiuserid==0 ? "系统" : "手动" }}取消{{ item.takeProfitFrom&&parseFloat(item.takeProfitTo).toFixed(0)==0 ? "止盈" : "止损" }}
                    </div>
                    <div v-else>
                      <div v-if="item.takeProfitFrom&&item.takeProfitTo">止盈 : {{ parseFloat(item.takeProfitFrom).toFixed(0)==0 ? "没有设置" : parseFloat(item.takeProfitFrom) }} --> {{ parseFloat(item.takeProfitTo) }}</div>
                      <div v-if="item.stopLossFrom&&item.stopLossTo">止损 : {{ parseFloat(item.stopLossFrom).toFixed(0)==0 ? "没有设置" : parseFloat(item.stopLossFrom) }} --> {{ parseFloat(item.stopLossTo) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="noData">没有数据</div>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeStopPop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
import api from '@/plugins/api'
export default {
  name: 'StopLossRecord',
  components: { noData },
  props: ['stop', 'isBrushTradePop', 'stopAcID'],
  data() {
    return {
      isShowStop: false,
      stopRecordList: '',
      test: '',
      positionId: '',
      fullapi: '',
      isSearchPage: false,
      searchStopResult: [],
      scrollHeight: '',
      beginTime: utils.getLast1Month(new Date()).beginTime.replace(/\//gi, '-'),
      endTime: utils.getLast1Month(new Date()).endTime.replace(/\//gi, '-'),
      platform: 'GTS2',
      pattern: this.$route.query.pattern || '',
      timeZones: this.$route.query.timeZones || ('GMT+8')
    }
  },
  computed: {

  },
  methods: {
    submit() {
      // let isShowTradeType = this.isBrushTradePop;
      // isShowTradeType = !isShowTradeType;
      this.$emit('blushPop', this.positionId)
      // this.isSearchPage = false;
      // this.searchStopResult = [];
      // $('.reportTit').css('display','none');
      // if (this.positionId) {
      //     // get full api
      //     let options = {
      //         index: 1,
      //         pageSize: 999,
      //         beginTime: this.beginTime,
      //         endTime: this.endTime,
      //         platform: this.platform,
      //         gts2AccountId: this.stopAcID,
      //         Authorization: this.$route.query.token,
      //         orderId: this.positionId,
      //     };
      //     api.stopLossRecordList(this.$qs.stringify(options)).then(res=>{
      //         if (res.status) {
      //             if (res.data.code == 200){
      //                 this.$bus.$emit('loading', true);
      //                 this.stop = res.data.data;
      //             }
      //         }
      //     })
      // }
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    timeZone(val, type) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(Number(this.timeZones.substr(3)), val)
        if (type == 0) return new Date(localTime).format('Y-MM-dd')
        else if (type == 1) return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    closeStopPop() {
      this.removeStyle()
      this.isShowStop = false
      this.stopRecordList = ''
    },
    selectStopPro(data) {
      this.addStyle()
      const dataList = {
        positionId: data,
        gts2AccountId: this.stopAcID,
        Authorization: this.$route.query.token
      }
      api.stopLossRecord(dataList).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.stopRecordList = res.data.data
            this.isShowStop = !this.isShowStop
          }
        }
      })
    },
    selectBrush() {
      this.toggleFixed()
      let isShowTradeType = this.isBrushTradePop
      isShowTradeType = !isShowTradeType
      this.$emit('blushPop', isShowTradeType)
    }
  }
}
</script>
